'use strict';
var globalThis = require('../internals/global-this');
var path = require('../internals/path');

module.exports = function (CONSTRUCTOR, METHOD) {
  var Namespace = path[CONSTRUCTOR + 'Prototype'];
  var pureMethod = Namespace && Namespace[METHOD];
  if (pureMethod) return pureMethod;
  var NativeConstructor = globalThis[CONSTRUCTOR];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  return NativePrototype && NativePrototype[METHOD];
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/get-built-in-prototype-method.js
// module id = 40
// module chunks = 13